import { blue, cyan, green, jade, muted, orange, purple, red, yellow } from 'theme/palette';

type PresetName =
  | 'muted'
  | 'blue'
  | 'cyan'
  | 'green'
  | 'jade'
  | 'orange'
  | 'purple'
  | 'red'
  | 'yellow';

export default function getColorPresets(name: PresetName) {
  return {
    muted,
    blue,
    cyan,
    green,
    jade,
    orange,
    purple,
    red,
    yellow,
  }[name];
}
